import { render } from "./외래진료예약(진료과).vue?vue&type=template&id=5fc3b016"
import script from "./외래진료예약(진료과).vue?vue&type=script&lang=js"
export * from "./외래진료예약(진료과).vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__